import { render } from "./Main.vue?vue&type=template&id=a524d8f8"
const script = {}
script.render = render

export default script